import { TComputedPropMapper } from '../../types/computed-props-mapper';

export const isMoscow: TComputedPropMapper<boolean> = props => {
  const geo = props.offer.geo?.address || [];
  const isMoscow = geo.some(a => a.id === 1 || a.id === 4593);

  return isMoscow;
};
